module.exports = __webpack_public_path__ + "img/face1@2x.60e9614f.png";